/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'confluence-table-tree.column.contributors': 'Contribuidores',
  'confluence-table-tree.column.last-modified': 'Última modificação',
  'confluence-table-tree.column.title': 'Nome',
  'confluence-table-tree.could-not-load': 'Não foi possível carregar',
  'confluence-table-tree.could-not-load-contributors': 'Não foi possível carregar os colaboradores',
  'confluence-table-tree.create-child-page': 'Criar uma página filho',
  'confluence-table-tree.create-page': 'Criar página',
  'confluence-table-tree.default.page.title': 'Sem título',
  'confluence-table-tree.default.show-all-pages-button.label': 'Mostrar mais páginas',
  'confluence-table-tree.draft.lozenge': 'RASCUNHO',
  'confluence-table-tree.draft.tooltip': 'Só você pode ver os rascunhos.',
  'confluence-table-tree.drafts-toggle.label': 'Mostrar rascunhos',
  'confluence-table-tree.edit': 'Editar',
  'confluence-table-tree.edit-in-confluence': 'Editar no Confluence',
  'confluence-table-tree.empty.description':
    'Crie algumas anotações de reunião, requisitos de produtos, decisões ou outros assuntos para ver este espaço ser preenchido.',
  'confluence-table-tree.empty.title': 'Não há nada aqui além de potencial',
  'confluence-table-tree.error.description': 'Não podemos mostrar estas páginas para você. Tente de novo mais tarde.',
  'confluence-table-tree.error.row': 'Não é possível carregar páginas.',
  'confluence-table-tree.error.title': 'Poxa, isso está estranho...',
  'confluence-table-tree.friendly-when-created': 'Criado',
  'confluence-table-tree.friendly-when-updated': 'Atualizado',
  'confluence-table-tree.share.copied': 'Copiado para a área de transferência',
  'confluence-table-tree.share.copy-button': 'Copiar',
  'confluence-table-tree.share.subtitle': 'Compartilhar este link',
  'confluence-table-tree.share.title': 'Compartilhar página',
  'confluence-table-tree.share.tooltip': 'Compartilhar',
  'confluence-table-tree.view-profile': 'Visualizar perfil',
};
